export const USER_PROFILE_GET = '@USER_PROFILE_GET'
export const USER_PROFILE_GET_SUCCESS = '@USER_PROFILE_GET_SUCCESS'
export const USER_PROFILE_GET_FAILURE = '@USER_PROFILE_GET_FAILURE'

export default {
  USER_PROFILE_GET,
  USER_PROFILE_GET_SUCCESS,
  USER_PROFILE_GET_FAILURE
}
